import {useMutation, useQueryClient} from '@tanstack/react-query'

import {createParentCompany, updateParentCompany} from './api'
import {parentCompanyKeys} from './keys'
import {ParentCompanyRequest, ParentCompanyResponse} from './types'

export const useCreateParentCompanyMutation = () => {
  const queryClient = useQueryClient()

  return useMutation<ParentCompanyResponse, unknown, ParentCompanyRequest>({
    mutationFn: createParentCompany,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: parentCompanyKeys.list()})
    },
  })
}

export const useUpdateParentCompanyMutation = () => {
  const queryClient = useQueryClient()

  return useMutation<ParentCompanyResponse, unknown, {id: string; body: ParentCompanyRequest}>({
    mutationFn: ({id, body}) => updateParentCompany(id, body),
    onSuccess: (_, {id}) => {
      queryClient.invalidateQueries({queryKey: parentCompanyKeys.detail(id)})
      queryClient.invalidateQueries({queryKey: parentCompanyKeys.list()})
    },
  })
}
